import { render, staticRenderFns } from "./VuePagination.vue?vue&type=template&id=5428b29c"
import script from "./VuePagination.vue?vue&type=script&lang=js"
export * from "./VuePagination.vue?vue&type=script&lang=js"
import style0 from "./VuePagination.vue?vue&type=style&index=0&id=5428b29c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports